<template>
  <nav class="app-bottom-nav" aria-label="주요 메뉴">
    <NuxtLink
      v-for="item in items"
      :key="item.id"
      :to="item.to"
      class="app-bottom-nav__item"
      :class="{ 'app-bottom-nav__item--active': isActive(item) }"
      :aria-current="isActive(item) ? 'page' : undefined"
    >
      <img :src="item.icon" alt="" />
      <span>{{ item.label }}</span>
    </NuxtLink>
  </nav>
</template>

<script setup>
import navHome from "@/assets/images/nav-home.svg?url";
import navProtection from "@/assets/images/nav-protection.svg?url";
import navFamily from "@/assets/images/nav-family.svg?url";
import navContent from "@/assets/images/nav-content.svg?url";
import navMy from "@/assets/images/nav-my.svg?url";

const route = useRoute();

const items = [
  { id: "home", label: "홈", to: "/main", match: ["/main"], icon: navHome },
  { id: "device", label: "단말보호", to: "/device", match: ["/device"], icon: navProtection },
  { id: "family", label: "가족보호", to: "/family", match: ["/family"], icon: navFamily },
  { id: "contents", label: "콘텐츠", to: "/magazine/financial-magazine", match: ["/magazine"], icon: navContent },
  { id: "my", label: "MY", to: "/mypage", match: ["/mypage"], icon: navMy },
];

const isActive = (item) =>
  item.match.some((path) => route.path === path || route.path.startsWith(`${path}/`));
</script>
